var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-forms-regiter"},[_c('form-fields',{attrs:{"fields":_vm.fields},on:{"save":_vm.completeRegister,"update:values":function($event){_vm.inputsValues = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }